// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Spacer_Ds = require("./Particle_Spacer_Ds.bs.js");

var mobile = Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "M", undefined);

var desktop = Particle_Spacer_Ds.makeVerticalAndHorizontal("L", "XL", undefined);

var firstMobile = Particle_Spacer_Ds.makeVerticalAndHorizontal("Zero", "M", undefined);

var firstDesktop = Particle_Spacer_Ds.makeVerticalAndHorizontal("Zero", "XL", undefined);

var withBackgroundMobile = Particle_Spacer_Ds.Both.make({
      top: "S",
      bottom: "S",
      left: "M",
      right: "M"
    }, {
      top: "S",
      bottom: "S",
      left: "M",
      right: "M"
    }, undefined);

var withBackgroundDesktop = Particle_Spacer_Ds.Both.make({
      top: "L",
      bottom: "L",
      left: "XL",
      right: "XL"
    }, {
      top: "L",
      bottom: "L",
      left: "Zero",
      right: "Zero"
    }, undefined);

var afterTopTeaserMobile = Particle_Spacer_Ds.make("Zero", "S", "M", "M", undefined);

var afterTopTeaserDesktop = Particle_Spacer_Ds.make("Zero", "L", "XL", "XL", undefined);

var Slider = {
  withBackgroundMobile: withBackgroundMobile,
  withBackgroundDesktop: withBackgroundDesktop,
  afterTopTeaserMobile: afterTopTeaserMobile,
  afterTopTeaserDesktop: afterTopTeaserDesktop
};

var Zone_defaultSpacerHorizontalValues = {
  default: "M",
  m: "XL"
};

var Zone = {
  defaultSpacerHorizontalValues: Zone_defaultSpacerHorizontalValues,
  mobile: mobile,
  desktop: desktop,
  firstMobile: firstMobile,
  firstDesktop: firstDesktop,
  Slider: Slider
};

var mobile$1 = Particle_Spacer_Ds.makeHorizontal("M");

var desktop$1 = Particle_Spacer_Ds.makeHorizontal("XL");

var PlayNext = {
  mobile: mobile$1,
  desktop: desktop$1
};

var mobile$2 = Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "M", undefined);

var desktop$2 = Particle_Spacer_Ds.make("XL", "L", "XL", "XL", undefined);

var ProgramContent = {
  mobile: mobile$2,
  desktop: desktop$2
};

var mobile$3 = Particle_Spacer_Ds.makeTop("M");

var desktop$3 = Particle_Spacer_Ds.makeTop("XL");

var Label = {
  mobile: mobile$3,
  desktop: desktop$3
};

var ProgramPage = {
  PlayNext: PlayNext,
  ProgramContent: ProgramContent,
  Label: Label
};

var dropdown = Particle_Spacer_Ds.makeTop("S");

var grid = Particle_Spacer_Ds.makeTop("L");

var ListPage = {
  dropdown: dropdown,
  grid: grid
};

var allZero = Particle_Spacer_Ds.makeAll("Zero");

exports.Zone = Zone;
exports.ProgramPage = ProgramPage;
exports.ListPage = ListPage;
exports.allZero = allZero;
/* mobile Not a pure module */
